module.exports = __webpack_public_path__ + "img/privacy-shield.7de4b9d2.png";